import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component PersonArrowOutCircleIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <PersonArrowOutCircleIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <PersonArrowOutCircleIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const PersonArrowOutCircleIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="PersonArrowOutCircleIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M12 2q.507 0 1.001.05L13 3.5q0 .286.024.566a8 8 0 0 0-6.883 13.38A4 4 0 0 1 8.122 16.4 19.3 19.3 0 0 1 12 16q1.939 0 3.877.398c.76.156 1.444.525 1.983 1.048A7.97 7.97 0 0 0 20 12c0-.69-.087-1.36-.252-2H21.8q.198.97.2 2a9.97 9.97 0 0 1-2.85 6.99l-.224.223-.329.302-.325.274-.353.272-.314.222-.345.223A9.95 9.95 0 0 1 12 22a9.95 9.95 0 0 1-4.951-1.31l-.33-.197-.324-.21-.374-.266-.137-.105-.223-.177-.293-.25-.295-.273A9.97 9.97 0 0 1 2 12C2 6.477 6.477 2 12 2m0 16q-1.735 0-3.476.357a2 2 0 0 0-.831.385A7.96 7.96 0 0 0 12 20a7.96 7.96 0 0 0 4.307-1.257 2 2 0 0 0-.832-.386A17.3 17.3 0 0 0 12 18m0-11a4 4 0 1 1 0 8 4 4 0 0 1 0-8m0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m6-8v3h-3v2h3v3l5-4z"
        clipRule="evenodd"
      />
    </svg>
  )
);
PersonArrowOutCircleIcon.displayName = "PersonArrowOutCircleIcon";
export default PersonArrowOutCircleIcon;
